<template>
  <div class="content-1">
    <div class="title-1">{{ $t('content87') }}</div>
    <div class="title-2">{{ $t('content88') }}</div>
    <!-- <div class="btn-box">
      <div class="btn-blue">预约演示</div>
      <div class="btn-we">参观一下</div>
    </div> -->

    <div class="con-1">
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_303.png'):require('@/assets/en_img_303.png')" class="con-1-img" alt="">
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_302.png'):require('@/assets/en_img_302.png')" class="con-2-img" alt="">
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_301.png'):require('@/assets/en_img_301.png')" class="con-3-img" alt="">
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_00.png'): require('@/assets/en_img_00.png')" class="con-4-img" alt="">

      <div class="con-box-text">{{ animatedNumber1 }}</div>
      <div class="con-box-text1">{{ animatedNumber2 }}</div>
    </div>

    <div class="con-2">
      <div class="con-3">
        {{ $t('content89') }}</div>

      <div class="con-4">
        <div :class="$i18n.locale + '_con-6-bot'">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/Frame 342@2x.png'):require('@/assets/en_Frame 342@2x.png')" class="con-5" alt="">
          <div :class="$i18n.locale + '_con-6'">{{ $t('content90') }}</div>
        </div>
        <div>
          <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img2@2x.png'):require('@/assets/en_zidonghua_img2@2x.png')" class="con-5" alt="">
          <div :class="$i18n.locale + '_con-6'">{{ $t('content91') }}</div>
        </div>
        <div>
          <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img3@2x.png'):require('@/assets/en_zidonghua_img3@2x.png')" class="con-5" alt="">
          <div :class="$i18n.locale + '_con-6'">{{ $t('content92') }}</div>
        </div>
        <div>
          <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img4@2x.png'):require('@/assets/en_zidonghua_img4@2x.png')" class="con-5" alt="">
          <div :class="$i18n.locale + '_con-6'">{{ $t('content93') }}</div>
        </div>
        <div>
          <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img5 @2x.png'):require('@/assets/en_zidonghua_img5 @2x.png')" class="con-5" alt="">
          <div class="con-7">
            {{ $t('content94') }}</div>
        </div>
        <div>
          <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img6@2x.png'):require('@/assets/en_zidonghua_img6@2x.png')" class="con-5" alt="">
          <div  :class="$i18n.locale + '_con-6'">{{ $t('content95') }}</div>
        </div>
      </div>
    </div>

    <div class="con-8">
      <div class="con-9">
        <img :src="$i18n.locale == 'zh' ? require('@/assets/dazao_img@2x.png'):require('@/assets/en_dazao_img@2x.png')" class="con-9-img" alt="">
      </div>
      <div :class="$i18n.locale + '_con-10'">
        <div class="con-11">{{ $t('content96') }}</div>
        <div class="con-12">
          <img src="@/assets/Slice 25@2x.png" class="con-12-img" alt="">
          <div class="con-13">
            {{ $t('content97') }}</div>
        </div>
        <div class="con-14">
          <img src="@/assets/Slice 25@2x.png" class="con-12-img" alt="">
          <div class="con-15">{{ $t('content98') }}</div>
        </div>
        <div class="con-14">
          <img src="@/assets/Slice 25@2x.png" class="con-12-img" alt="">
          <div class="con-15">{{ $t('content99') }}</div>
        </div>

      </div>
    </div>

    <div class="con-16">{{ $t('content100') }}
    </div>
    <div class="con-17">{{ $t('content101') }}
    </div>

    <div class="con-18">
      <div :class="$i18n.locale + '_con-19'">
        <div class="con-20">
          <img src="@/assets/bank_icon@2x.png" class="con-20-img" alt="">
        </div>
        <div class="con-21">{{ $t('content102') }}</div>
        <div class="con-22">
          {{ $t('content103') }}</div>
        <div>
          <!-- <img src="@/assets/img_401.png" class="con-22-img" alt="">
          <img src="@/assets/img_404.png" class="con-img-1" alt="">
          <div class="text-title-1">付款至</div>
          <div class="text-title-2">Chen@gmail.com</div>
          <div class="text-title-3">付款金额</div>
          <div class="text-title-4">
            <img src="@/assets/img_402.png" class="con-img-2" alt="">

          </div>
          <div class="con-img-4">198.00 USD</div>
          <div class="con-img-5-box"></div>
          <img src="@/assets/sharpicons_pantheon.png" class="con-img-5" alt="">
          <div class="animation-lines-container" ref="linesContainer"></div> -->
          <img :src="$i18n.locale == 'zh' ? require('@/assets/Slice 34@2x.png'):require('@/assets/en_Slice 34@2x.png')"  alt="" :class="$i18n.locale + '_con-22-img'">
        </div>

      </div>
      <div class="con-19">
        <div class="con-20">
          <img src="@/assets/shoukuanfangshi_icon@2x.png" class="con-20-img" alt="">
        </div>
        <div class="con-21">
          {{ $t('content104') }}</div>
        <div class="con-22">
          {{ $t('content105') }}</div>
        <!-- <img src="@/assets/img_708.png" class="con-23-img" alt="">
        <img src="@/assets/img_700.png" class="con-img-3" alt="">
        <img src="@/assets/img_701.png" class="con-img-6" alt="">
        <img src="@/assets/img_706.png" class="con-img-7" alt="">
        <img src="@/assets/img_707.png" class="con-img-8" alt="">
        <img src="@/assets/img_705.png" class="con-img-9" alt="">
        <div class="con-img-9-box">请选择付款方式</div>
        <img src="@/assets/img_703.png" class="con-img-10" alt="">
        <img src="@/assets/img_702.png" class="con-img-11" alt="">
        <img src="@/assets/img_704.png" class="con-img-12" alt=""> -->
        <img :src="$i18n.locale == 'zh' ? require('@/assets/Slice 35@2x.png'):require('@/assets/en_Slice 35@2x.png')" :class="$i18n.locale + '_con-23-img'" alt="">
      </div>

    </div>

    <div class="con-23">
      <div>
        <div class="con-24">
          <img src="@/assets/fentan_icon@2x.png" class="con-24-img" alt="">
        </div>
        <div class="con-25">
          {{ $t('content106') }}</div>
        <div class="con-26">
          {{ $t('content107') }}</div>
      </div>
      <div class="con-27">
        <img src="@/assets/fentan_img@2x.png" class="con-27-img" alt="">
      </div>
    </div>
  </div>
</template>

<script>
//import

export default {
  name: 'payMent',
  components: {

  },
  data() {
    return {
      animatedNumber1: 0,
      animatedNumber2: 0.00,
      isAnimating1: false,
      isAnimating2: false,
      animationCount1: 0,
      animationCount2: 0,
      animationInterval: null
    };
  },
  computed: {

  },
  watch: {},
  methods: {
    animateNumbers() {
      // 限制动画次数，防止无限循环
      const MAX_ANIMATION_CYCLES = 10

      // 第一个数字动画：从0到6454
      if (!this.isAnimating1 && this.animationCount1 < MAX_ANIMATION_CYCLES) {
        this.isAnimating1 = true
        this.animationCount1++

        this.animateNumberTo(this.animatedNumber1, 6454, (value) => {
          this.animatedNumber1 = Math.round(value)
        }, () => {
          // 动画结束后停留4秒，然后重置为0并重新开始
          setTimeout(() => {
            this.animatedNumber1 = 0
            this.isAnimating1 = false

            // 如果未达到最大循环次数，继续动画
            if (this.animationCount1 < MAX_ANIMATION_CYCLES) {
              this.animateNumbers()
            }
          }, 6300)
        })
      }

      // 第二个数字动画：从0.00到762245.00
      if (!this.isAnimating2 && this.animationCount2 < MAX_ANIMATION_CYCLES) {
        this.isAnimating2 = true
        this.animationCount2++

        this.animateNumberTo(this.animatedNumber2, 762245.00, (value) => {
          // 确保value是数字
          this.animatedNumber2 = Number(value).toFixed(2)
        }, () => {
          // 动画结束后停留4秒，然后重置为0并重新开始
          setTimeout(() => {
            this.animatedNumber2 = 0.00
            this.isAnimating2 = false

            // 如果未达到最大循环次数，继续动画
            if (this.animationCount2 < MAX_ANIMATION_CYCLES) {
              this.animateNumbers()
            }
          }, 6300)
        })
      }
    },
    animateNumberTo(start, end, updateCallback, onCompleteCallback, duration = 2000) {
      // 如果起始值和结束值相同，直接返回
      if (start === end) {
        updateCallback(end)
        onCompleteCallback()
        return
      }

      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)

        // 使用缓和函数使动画更平滑
        const easeOutQuad = progress * (2 - progress)
        const currentValue = start + (end - start) * easeOutQuad

        updateCallback(currentValue)

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          // 动画完成时调用回调函数
          onCompleteCallback()
        }
      }

      requestAnimationFrame(animate)
    },
    createAnimationLines() {
      const container = this.$refs.linesContainer

      // 清除之前的线条
      container.innerHTML = ''

      // 定义5种随机颜色
      const colors = ['#3498db', '#e74c3c', '#2ecc71', '#f39c12', '#9b59b6']

      // 预定义的角度
      const angles = [0, 72, 144, 216, 288]

      // 创建5条线条
      for (let i = 0; i < 5; i++) {
        const lineWrapper = document.createElement('div')
        lineWrapper.style.position = 'absolute'
        lineWrapper.style.width = '300px'
        lineWrapper.style.height = '300px'
        lineWrapper.style.left = '50%'
        lineWrapper.style.top = '50%'
        lineWrapper.style.transform = `translate(-50%, -50%) rotate(${angles[i]}deg)`
        lineWrapper.style.pointerEvents = 'none'

        const line = document.createElement('div')
        line.style.position = 'absolute'
        line.style.width = '4px'
        line.style.height = '0'
        line.style.backgroundColor = colors[i]
        line.style.left = '50%'
        line.style.bottom = '50%'
        line.style.transformOrigin = 'bottom center'
        line.style.transform = 'translateX(-50%)'

        // 直接使用 Web Animations API
        line.animate([
          {
            height: '0px',
            transform: 'translateX(-50%) scaleY(0)',
            opacity: 0
          },
          {
            height: '150px',
            transform: 'translateX(-50%) scaleY(1)',
            opacity: 1
          },
          {
            height: '150px',
            transform: 'translateX(-50%) scaleY(0)',
            opacity: 0
          }
        ], {
          duration: 2000,
          easing: 'ease-out',
          fill: 'forwards'
        })

        lineWrapper.appendChild(line)
        container.appendChild(lineWrapper)
      }
    },
    startLineAnimation() {
      // 每隔3秒创建一次动画线条
      this.animationInterval = setInterval(() => {
        this.createAnimationLines()
      }, 3000)
    },
    stopLineAnimation() {
      if (this.animationInterval) {
        clearInterval(this.animationInterval)
      }
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  beforeUnmount() {
    this.stopLineAnimation()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.animateNumbers()
      // this.createAnimationLines()
      // this.startLineAnimation()
    })
  }
}
</script>
<style scoped>
.content-1 {
  /* min-height: 200vh;
    height: 100%; */
  padding-top: 87px;
  margin: 0 auto
}

.con-1 {
  margin: 0 auto;
  padding: 0 auto;
  text-align: center;
  padding-bottom: 200px;
}

.con-1-img {
  width: 1400px;
  height: 800px;
}

.con-2 {
  height: 1014px;
  background-color: #F8F9FF;
  margin: 0 auto;
  padding-top: 90px;
}

.con-4 {
  width: 1208px;
  height: 770px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
}

.title-1 {
  margin-top: 87px;
  font-size: 36px;
  color: #333;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 18px;

}

.con-5 {
  width: 368px;
  height: 264px;
}

.en_con-6-bot{
    margin-bottom: 30px;
}

.zh_con-6 {
  font-size: 20px;
  color: #333333;
  text-align: center;
  padding-top: 16px;
  line-height: 32px;
}

.en_con-6 {
  font-size: 20px;
  color: #333333;
  text-align: center;
  padding-top: 16px;
  line-height: 32px;
  width:400px
}

.con-7 {
  font-size: 18px;
  color: #333333;
  width: 332px;
  text-align: center;
  margin-left: 27px;
  line-height: 32px;
}

.title-2 {
  width: 960px;
  font-size: 22px;
  color: #666666;
  text-align: center;
  margin: 0 auto;
}

.con-3 {
  margin-top: 90px;
  font-size: 36px;
  color: #333333;
  text-align: center;
  width: 761px;
  margin: 0 auto;
  margin-bottom: 47px;
  font-weight: 600;

}

.con-8 {
  display: flex;
}

.con-9 {
  margin-top: 91px;
  margin-left: 294px;
}

.con-9-img {
  width: 667px;
  height: 540px;
}

.en_con-10 {
  margin-left: 50px;
  margin-top: 200px;
  width:700px
}

.zh_con-10 {
  margin-left: 87px;
  margin-top: 237px;
}

.con-11 {
  font-size: 36px;
  color: #333333;
  margin-bottom: 27px;
  font-weight: 600;

}

.con-12 {
  display: flex;
  align-items: center;
}

.con-12-img {
  width: 18px;
  height: 18px;
}

.con-13 {
  font-size: 20px;
  color: #333333;
  margin-left: 12px;
  width: 476px;
  line-height: 32px;
}

.con-14 {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.con-15 {
  font-size: 20px;
  color: #333333;
  margin-left: 12px;
}

.con-16 {
  font-size: 36px;
  color: #333333;
  text-align: center;
  margin-bottom: 15px;
  line-height: 58px;
  font-weight: 600
}

.con-17 {
  font-size: 22px;
  color: #666666;
  text-align: center;
  margin-bottom: 59px;
}

.con-18 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.zh_con-19 {
  width: 580px;
  height: 760px;
  background-color: #F8F9FF;
  border-radius: 30px;
}

.en_con-19 {
  width: 580px;
  height: 860px;
  background-color: #F8F9FF;
  border-radius: 30px;
}

.con-20 {
  margin: 47px 0 33px 47px;
}

.con-20-img {
  width: 54px;
  height: 54px;
}

.con-21 {
  font-size: 24px;
  color: #333333;
  margin-bottom: 8px;
  margin-left: 47px;
}

.con-22 {
  font-size: 20px;
  color: #666666;
  width: 487px;
  margin-left: 47px;
  margin-bottom: 16px;
  line-height: 32px;
}

.zh_con-22-img {
  width: 408px;
  height: 400px;
  position: absolute;
  left: 430px;
  top: 3450px;
}

.en_con-22-img {
  width: 408px;
  height: 400px;
  position: absolute;
  left: 430px;
  top: 3600px;
}

.zh_con-23-img {
  width: 550px;
  height: 500px;
  position: absolute;
  left: 1000px;
  top: 3360px;
}

.en_con-23-img {
  width: 550px;
  height: 500px;
  position: absolute;
  left: 920px;
  top: 3520px;
}

@keyframes moveConImg7 {
  0% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(50px, 50px);
  }

  100% {
    transform: translate(50px, 50px);
  }
}

@keyframes moveConImg3 {
  0% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(-10px, 30px);
  }

  100% {
    transform: translate(-10px, 30px);
  }
}

@keyframes moveConImg6 {
  0% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(-30px, -20px);
  }

  100% {
    transform: translate(-30px, -20px);
  }
}

.con-img-3 {
  width: 70px;
  height: 70px;
  position: absolute;
  left: 1030px;
  top: 3650px;
  animation: moveConImg3 3s ease-in-out infinite;
  animation-delay: 1s;
}

.con-img-6 {
  width: 80px;
  height: 80px;
  position: absolute;
  right: 450px;
  top: 3610px;
  z-index: 99;
  animation: moveConImg6 3s ease-in-out infinite;
  animation-delay: 1s;
}

.con-img-7 {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 980px;
  top: 3840px;
  animation: moveConImg7 3s ease-in-out infinite;
  animation-delay: 1s;
}

.con-img-3,
.con-img-6,
.con-img-7 {
  position: absolute;
  offset-rotate: 0deg;
}

.con-23 {
  width: 1200px;
  height: 356px;
  background-color: #F8F9FF;
  margin: 0 auto;
  margin-top: 37px;
  display: flex;
  border-radius: 30px;
}

.con-24 {
  margin: 47px 0 23px 47px;
}

.con-24-img {
  width: 54px;
  height: 54px;
}

.con-25 {
  font-size: 24px;
  color: #333333;
  margin-bottom: 8px;
  margin-left: 47px;
  line-height: 58px;
}

.con-26 {
  font-size: 20px;
  color: #666666;
  width: 487px;
  margin-left: 47px;
  margin-bottom: 16px;
  line-height: 32px;
}

.con-27 {
  margin: 16px 14px 16px 0;
}

.con-27-img {
  width: 600px;
  height: 324px;
}

.con-29 {
  font-size: 36px;
  color: #fff;
  position: absolute;
  top: 60px;
  left: 360px;
}

.con-30 {
  font-size: 18px;
  color: #fff;
  position: absolute;
  top: 137px;
  left: 360px;
}

.con-31 {
  display: flex;
  position: absolute;
  top: 99px;
  right: 360px;
}

.con-32 {
  width: 132px;
  height: 44px;
  border-radius: 4px;
  background-color: #4873FF;
  color: #fff;
  text-align: center;
  line-height: 44px;
  margin-right: 24px;
  font-size: 18px;
  cursor: pointer;

}

.con-33 {
  width: 132px;
  height: 44px;
  border-radius: 4px;
  background-color: #17152c;
  color: #4873FF;
  text-align: center;
  line-height: 44px;
  font-size: 18px;
  cursor: pointer;

  border: 1px solid #4873FF;
}

.btn-box {
  margin-top: 58px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 49px;
}

.btn-blue {
  width: 132px;
  height: 44px;
  font-size: 18px;
  background-color: #4873FF;
  color: #fff;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  margin-right: 12px;
  cursor: pointer;

}

.btn-we {
  width: 132px;
  height: 44px;
  font-size: 18px;
  background-color: #fff;
  color: #4873FF;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  border: 1px solid #4873FF;
  margin-left: 12px;
  cursor: pointer;


}

.con-99 {
  display: flex;
}

@keyframes slide-left-to-right {

  0%,
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }

  20%,
  80% {
    transform: translateX(0);
    opacity: 1;
  }

  50% {
    transform: translateX(0);
    opacity: 1;
  }

  /* 10%, 90% {
    transform: translateX(0);
    opacity: 1;
  }
  0%, 50%, 100% {
    transform: translateX(-100%);
    opacity: 0;
  } */
}

@keyframes slide-right-to-left {

  0%,
  100% {
    transform: translateX(100%);
    opacity: 0;
  }

  20%,
  80% {
    transform: translateX(0);
    opacity: 1;
  }

  50% {
    transform: translateX(0);
    opacity: 1;
  }
}

.con-2-img {
  width: 900px;
  height: 600px;
  position: absolute;
  top: 620px;
  left: 170px;
  opacity: 0;
  transform: translateX(-100%);
  animation:
    slide-left-to-right 8s cubic-bezier(0.4, 0, 0.2, 1) infinite;

}

.con-3-img,
.con-4-img {
  animation:
    slide-right-to-left 8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.con-box-text,
.con-box-text1 {
  transition: all 2s ease-out;
  animation:
    slide-right-to-left 8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.con-3-img {
  width: 300px;
  height: 150px;
  position: absolute;
  top: 635px;
  right: 240px;
  animation-delay: 0.3s;
}

.con-4-img {
  width: 300px;
  height: 150px;
  position: absolute;
  top: 780px;
  right: 190px;
  animation-delay: 0.6s;
}

.con-box-text {
  position: absolute;
  top: 690px;
  right: 360px;
  z-index: 1;
  font-size: 24px;
  font-weight: 600;
  animation-delay: 0.4s;
}

.con-box-text1 {
  position: absolute;
  top: 840px;
  right: 250px;
  z-index: 1;
  font-size: 24px;
  font-weight: 600;
  animation-delay: 0.7s;
}

.con-img-1 {
  position: absolute;
  top: 3850px;
  left: 380px;
  width: 300px;
}

.text-title-1 {
  color: #666666;
  font-size: 16px;
  position: absolute;
  top: 3890px;
  left: 420px;
}

.text-title-2 {
  color: #666666;
  font-size: 16px;
  position: absolute;
  top: 3915px;
  left: 420px;
}

.text-title-3 {
  color: #666666;
  font-size: 16px;
  position: absolute;
  top: 3955px;
  left: 420px;
}

.text-title-4 {
  color: #666666;
  font-size: 16px;
  position: absolute;
  top: 3985px;
  left: 420px;
  /* width:300px; */
  z-index: 99;
}

.con-img-2 {
  width: 200px;
}

.con-img-4 {
  color: #666666;
  font-size: 16px;
  position: absolute;
  top: 3992px;
  left: 470px;
  z-index: 5000;
  font-weight: 600;
}

.con-img-5-box {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  top: 3752px;
  left: 720px;
}

.con-img-5 {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 3760px;
  left: 730px;
}

.animation-lines-container {
  position: absolute;
  top: 3320px;
  left: -210px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}

.curved-line {
  position: absolute;
  width: 300px;
  height: 300px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(var(--angle));
  pointer-events: none;
}

.curved-line::before {
  content: '';
  position: absolute;
  width: 4px;
  /* 增加线条宽度 */
  height: 0;
  background-color: var(--color);
  left: 50%;
  bottom: 50%;
  transform-origin: bottom center;
  animation: drawLine 2s ease-out forwards;
}

@keyframes drawLine {
  0% {
    height: 0;
    transform: translateX(-50%) scaleY(0);
    opacity: 0;
  }

  100% {
    height: 150px;
    transform: translateX(-50%) scaleY(1);
    opacity: 1;
  }

  /* 添加线条消失阶段 */
  100%,
  200% {
    height: 150px;
    transform: translateX(-50%) scaleY(0);
    opacity: 0;
  }

}

.con-img-8 {
  width: 300px;
  height: 320px;
  position: absolute;
  top: 3752px;
  right: 350px;
  opacity: 0;
  animation: fadeIn 2s ease-out forwards;
  animation-delay: 0s;
}

.con-img-9 {
  width: 180px;
  height: 40px;
  position: absolute;
  top: 3845px;
  right: 410px;
  opacity: 0;
  animation: fadeIn 2s ease-out forwards;
  animation-delay: 1s;
}

.con-img-9-box {
  font-size: 18px;
  position: absolute;
  top: 3810px;
  right: 435px;
  opacity: 0;
  animation: fadeIn 2s ease-out forwards;
  animation-delay: 0.5s;

}

.con-img-10 {
  width: 180px;
  height: 40px;
  position: absolute;
  top: 3890px;
  right: 410px;
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
  animation-delay: 1.5s;

}

.con-img-11 {
  width: 180px;
  height: 40px;
  position: absolute;
  top: 3935px;
  right: 410px;
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
  animation-delay: 2s;
}

.con-img-12 {
  width: 180px;
  height: 40px;
  position: absolute;
  top: 3980px;
  right: 410px;
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
  animation-delay: 2.5s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(20px);
  }
}

@keyframes sequentialFadeIn {

  0%,
  5% {
    opacity: 0;
    transform: translateY(-20px);
  }

  10%,
  50% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(20px);
  }
}

.con-img-8,
.con-img-9,
.con-img-9-box,
.con-img-10,
.con-img-11,
.con-img-12 {
  will-change: opacity, transform;
  transition: opacity 0.5s ease, transform 1s ease;
}

.con-img-8 {
  animation: sequentialFadeIn 8s infinite;
  animation-delay: 0s;
}

.con-img-9-box {
  animation: sequentialFadeIn 8s infinite;
  animation-delay: 0.5s;
}

.con-img-9 {
  animation: sequentialFadeIn 8s infinite;
  animation-delay: 1s;
}

.con-img-10 {
  animation: sequentialFadeIn 8s infinite;
  animation-delay: 1.5s;
}

.con-img-11 {
  animation: sequentialFadeIn 8s infinite;
  animation-delay: 2s;
}

.con-img-12 {
  animation: sequentialFadeIn 8s infinite;
  animation-delay: 2.5s;
}

/* 悬停时瞬间消失 */
.con-img-8:hover,
.con-img-9:hover,
.con-img-9-box:hover,
.con-img-10:hover,
.con-img-11:hover,
.con-img-12:hover {
  opacity: 0;
}
</style>